module.exports = __webpack_public_path__ + "media/icons/search-a-gray-d1ff32d7.png";